<div class="clr"></div>
<div *ngIf="showProgressBarLoad">
  <!-- <mat-progress-bar mode='indeterminate' color="warn"></mat-progress-bar> -->
  <div class="lmask"></div>
</div>
<div *ngIf="showCount" class="subResult">
  <mat-toolbar class="mat-toolbar listps fontPS" color="accent" style="color:#000">
    <div *ngIf="rowData.length != 0" style="width: 100%;">
      <i class="fa fa-book icon" aria-hidden="true"></i> &nbsp; Power Supply ({{rowData.length}}
      {{ rowData.length == 1 ? 'Result' : 'Results'}})
    </div>
    <div *ngIf="rowData.length == 0" style="width: 100%;">
      No Results Found
    </div>
  </mat-toolbar>

  <div class="wrapper">
    <!-- <div class="block_line" color="accent"></div> -->
    <mat-nav-list>
      <div *ngIf="showLoading">
        <div class="lmask"></div>
      </div>

      <div *ngFor="let searchdata of rowData;index as i">
        <p><b>Power Supply Name: </b>
          <!-- <button id="popup"
            (click)="openmaintainanceDialog(searchdata.powerSupplyId,searchdata.macAddress,maintDialog,maintDialogValidation)"
            [disabled]="disableEdit(searchdata.nodeName)" mat-icon-button title={{editTitle}} class="editIcon btn btn-white btn-animate">
            <i class="fa fa-edit" aria-hidden="true"></i>
          </button> -->
          <button *ngIf="editIconEnable === 1?false:true" (click)="openmaintainanceDialog(searchdata.powerSupplyId,searchdata.macAddress,maintDialog,maintDialogValidation)" title={{editTitle}}  class="roundIcon material-icons btn btn-white btn-animate" [disabled]="disableEdit(searchdata.nodeName) || editIconEnable===2">edit
          </button>
          <a *ngIf="telemetryEnable===0" (click)="telemetryUrl(searchdata.powerSupplyId)"
            title="Telemetry" class="roundIcon material-icons btn btn-white btn-animate">poll</a>
          <a *ngIf="telemetryEnable===2" title="Telemetry" class="roundIcon material-icons btn btn-white btn-animate">poll</a>
          <a id="{{i}}" *ngIf="searchdata.hasMajor == true && alertsEnable === 0"
            (click)="alertUrl(searchdata.powerSupplyId)" title="Alerts/Events"
            class="roundIcon material-icons btn btn-white btn-animate" style="color:#a90404">
            <span id="{{i}}" class="animated faa-flash">warning</span>
          </a>
          <a id="{{i}}" *ngIf="searchdata.hasMajor == true && alertsEnable === 2" title="Alerts/Events"
            class="roundIcon material-icons btn btn-white btn-animate" style="color:#a90404">
            <span id="{{i}}" class="animated faa-flash">warning</span>
          </a>
          <a id="{{i}}" *ngIf="searchdata.hasMajor != true && alertsEnable === 0"
          (click)="alertUrl(searchdata.powerSupplyId)" title="Alerts/Events"
            class="roundIcon material-icons btn btn-white btn-animate">
            <span id="{{i}}" class="">warning</span>
          </a>
          <a id="{{i}}" *ngIf="searchdata.hasMajor != true && alertsEnable === 2" title="Alerts/Events"
            class="roundIcon material-icons btn btn-white btn-animate">
            <span id="{{i}}" class="">warning</span>
          </a>&nbsp;

          <a *ngIf="detailsIconEnable === 0" (click)="detailsPS(searchdata.powerSupplyId)" title="PS Detailed View"
          class="ps_view pslink"><b>{{searchdata.powerSupplyName}}</b></a>
          <a *ngIf="detailsIconEnable === 2" title="PS Detailed View"><b>{{searchdata.powerSupplyName}}</b></a>
        </p>
        <p mat-list-item><b>MAC Address: </b>{{searchdata.macAddress}}</p>
        <p mat-list-item><b>Power Supply ID: </b>{{searchdata.powerSupplyId}}</p>
        <p mat-list-item><b>Node Name: </b>{{searchdata.nodeName}}<img *ngIf="searchdata.stormMode == 1" style="height: 30px; cursor:pointer;" matTooltip="Primary node is in Storm Mode" src="./assets/storm.png"></p>
        <p mat-list-item><b>Region: </b>{{searchdata.edfa}}</p>
        <p mat-list-item><b>Power Supply Address: </b>{{searchdata.houseNumber}} {{searchdata.powerSupplyAddress}} {{searchdata.crossstreet}} {{searchdata.city}} {{searchdata.state}} {{searchdata.zip}}</p>
        <p mat-list-item><b>Last Visit Date: </b>{{logDate}}</p>
        <p *ngIf="distance" mat-list-item><b>Distance: </b>{{searchdata.distance+" Miles"}}</p>
        <p mat-list-item><b>Latitude: </b>{{searchdata.gpsLatitude}}<b>, Longitude: </b>{{searchdata.gpsLongitude}}
        </p>
        <div class="block_line" color="accent"></div>
      </div><br>
    </mat-nav-list>
  </div>
</div>
<!-- Dialog template -->
<ng-template #maintDialog>
  <form class="example-form" [formGroup]="lastvisitValidations">
    <h2 class="fontPS" matDialogTitle>Edit Last Visit Info!</h2>
    <mat-dialog-content>
      <!--<mat-form-field appearance="fill" *ngIf="permissionValue">
        <mat-label class="fontPS typeofvisit">Type of Visit</mat-label>
        <mat-select formControlName="visittype" [(value)]="visittype" required>
          <mat-option *ngFor="let visitType of visitTypesinhouse" [value]="visitType">
            {{visitType}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="lastvisitValidations.get('visittype').hasError('required')">
          Please select the Visit Type
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" *ngIf="!permissionValue">
        <mat-label class="fontPS typeofvisit">Type of Visit</mat-label>
        <mat-select formControlName="visittype" [(value)]="visittype" required>
          <mat-option *ngFor="let visitType of visitTypesbp" [value]="visitType">
            {{visitType}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="lastvisitValidations.get('visittype').hasError('required')">
          Please select the Visit Type
        </mat-error>
      </mat-form-field>-->
        <mat-form-field appearance="fill" *ngIf="permissionValue">
            <mat-label class="fontPS typeofvisit">Type of Visit</mat-label>
            <mat-select formControlName="visittype" [(value)]="visittype" required>
                <mat-option *ngFor="let visitType of visitTypes" [value]="visitType">
                    {{visitType}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="lastvisitValidations.get('visittype').hasError('required')">
                Please select the Visit Type
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" *ngIf="!permissionValue" >
          <mat-label class="fontPS typeofvisit">Type of Visit</mat-label>
          <mat-select formControlName="visittype" [(value)]="visittype" required>
              <mat-option *ngFor="let visitTypesbp of visitTypesbp" [value]="visitTypesbp">
                  {{visitTypesbp}}
              </mat-option>
          </mat-select>
          <mat-error *ngIf="lastvisitValidations.get('visittype').hasError('required')">
              Please select the Visit Type
          </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <div class="example-button-row">
        <button mat-stroked-button [disabled]="!lastvisitValidations.valid" (click)="editPS(visittype)">Next</button>
        <button mat-stroked-button matDialogClose (click)="lastvisitValidations.reset();cancelOk();">Cancel</button>
      </div>
    </mat-dialog-actions>
  </form>
</ng-template>

<!-- Dialog template -->
<ng-template #maintDialogValidation>
  <form class="example-form">
    <h2 class="fontPS" matDialogTitle>This Power Supply is modified by {{logName | titlecase}} and it is pending for
      review, it can't be edited until the review gets complete.</h2>
    <mat-dialog-actions align="end">
      <div class="example-button-row">
        <!-- button mat-stroked-button (click)="validationOk(maintDialog,macAdd)">Yes</button> -->
        <button mat-stroked-button matDialogClose>Ok</button>
      </div>
    </mat-dialog-actions>
  </form>
</ng-template>
